<form class="form" [formGroup]="originForm">
  <span></span>
  <h2>Backup & Restore</h2>

  <label>Origin:</label>
  <select #originSelect
          formControlName="origin"
          [value]="origin()"
          (input)="selectOrigin(originSelect.value)">
    @if (!backupOrigins().includes(origin())) {
      <option [value]="origin()">{{ origin() || 'default' }}</option>
    }
    @for (origin of backupOrigins(); track origin) {
      <option [value]="origin">{{ origin || 'default' }}</option>
    }
  </select>

  <label>Older than:</label>
  <input type="datetime-local" step="1" formControlName="olderThan">

  <span><!-- Buttons --></span>
  <span class="buttons right">
  </span>
</form>

<div class="backup buttons">
  @if (store.account.admin) {
    <button #backupButton
            type="button"
            [disabled]="!originFormValid()"
            (click)="showBackupOptions()"
            i18n-title title="Create Backup" i18n>+ backup</button>
    <button #deleteButton
            type="button"
            class="delete-origin"
            [disabled]="!originFormValid()"
            (click)="deleteOrigin()"
            i18n-title title="Delete all from origin" i18n>&ndash; delete</button>
  }

  @if (!uploading()) {
    <button type="button"
            [disabled]="!originFormValid()"
            (click)="uploadFile.click()"
            i18n-title
            title="Upload Backup" i18n>+ upload</button>
  } @else {
    <app-loading />
  }
  <input #uploadFile
         type="file"
         class="upload"
         (change)="upload(uploadFile?.files || undefined)">

  @if (store.account.mod) {
    <button type="button"
            [disabled]="!originFormValid()"
            (click)="regen()"
            i18n-title
            title="Regenerate Metadata" i18n>♻️ regen</button>
  }
</div>

@for (e of serverError(); track e) {
  <span><!-- Unexpected Error --></span>
  <div class="error">{{ e }}</div>
}

<app-backup-list [list]="list()"
                 [origin]="origin()" />

<ng-template #backupOptions>
  <div class="popup bubble" (click)="$event.stopPropagation()" [formGroup]="backupOptionsForm">
    <div class="form">
      <label for="backupCache" i18n>Cache</label>
      <div>
        <input id="backupCache" type="checkbox" formControlName="cache">
      </div>
      <label for="backupRefs" i18n>Refs</label>
      <div>
        <input id="backupRefs" type="checkbox" formControlName="ref">
      </div>
      <label for="backupExts" i18n>Exts</label>
      <div>
        <input id="backupExts" type="checkbox" formControlName="ext">
      </div>
      <label for="backupUsers" i18n>Users</label>
      <div>
        <input id="backupUsers" type="checkbox" formControlName="user">
      </div>
      <label for="backupPlugins" i18n>Plugins</label>
      <div>
        <input id="backupPlugins" type="checkbox" formControlName="plugin">
      </div>
      <label for="backupTemplates" i18n>Templates</label>
      <div>
        <input id="backupTemplates" type="checkbox" formControlName="template">
      </div>
      <label for="backupTombstones" i18n>Tombstones</label>
      <div>
        <input id="backupTombstones" type="checkbox" formControlName="tombstones">
      </div>
    </div>
    <hr>
    <div class="form">
      <div>
        <label for="newerThan" i18n>Newer than:</label>
        <div class="form-array">
          <input type="datetime-local"
                 id="newerThan"
                 step="1"
                 formControlName="newerThan"
                 class="grow">
          <button type="button" (click)="backupOptionsForm.get('newerThan')!.setValue('')" i18n-title title="Clear" i18n>🆑️</button>
        </div>
      </div>
    </div>

    <div class="buttons right">
      <button type="button" (click)="confirmBackup()" i18n>+ backup</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteConfirm>
  <div class="popup bubble delete-confirm" (click)="$event.stopPropagation()">
    <label for="deleteConfirmation" i18n>Are you sure you want totally delete everything in {{ originLabel() }}?<br>Enter the origin to confirm:</label>
    <input #confirmInput
           id="deleteConfirmation"
           type="text"
           class="delete-confirmation"
           autocomplete="off"
           appAutofocus
           [value]="deleteConfirmation()"
           (input)="deleteConfirmation.set(confirmInput.value)"
           (keydown.enter)="confirmDeleteOrigin()"
           (keydown.escape)="closeDeleteConfirm()">
    <div class="buttons right">
      <button type="button" (click)="closeDeleteConfirm()" i18n>cancel</button>
      <button type="button"
              class="confirm-delete"
              (click)="confirmDeleteOrigin()"
              [disabled]="deleteConfirmation() !== originLabel()"
              i18n>&ndash; delete</button>
    </div>
  </div>
</ng-template>
